import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {TokenInterceptor} from './shared/token.interceptor';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {CommonModule, HashLocationStrategy, LocationStrategy} from '@angular/common';
import {SharedModule} from './shared/shared.module';
import {LayoutsModule} from './layouts/layouts.module';
import {ErrorModule} from './error/error.module';
import {ManageUserModule} from './manage-user/manage-user.module';
import {CanActivateViaAuthGuard} from './shared/services/guards/auth-guard.service';
import {StorageService} from './shared/services/storage.service';
import {AdminService} from './shared/services/admin.service';
import {NotAuthorizedAdminGuard} from './shared/services/guards/not-authorized-admin-guard';
import {CanActivateViaAuthSuperAdminAuth} from './shared/services/guards/auth-super-admin-guard';
import {LoadPageService} from './shared/services/load-page.service';
import {CustomerService} from './shared/services/customer.service';
import {AuthGuard} from './shared/guards/auth.guard';
import {MailService} from './shared/services/mail.service';
import {ManageMailModule} from './manage-mail/manage-mail.module';
import {ManageOffreModule} from './manage-offre/manage-offre.module';
import {OffreService} from './shared/services/offre.service';
import {TranslateModule, TranslateStore} from '@ngx-translate/core';
import { LandingPageService } from './shared/services/landing-page.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ManageMenuModule } from './manage-menu/manage-menu.module';
import { ManageProjectsModule } from './manage-projects/manage-projects.module';
import { ManageUsersModule } from './manage-users/manage-users.module';
import { AddClientComponent } from './client/add-clients/add-client.component';
import { ClientModule } from './client/client.module';
import { ExcelUploadComponent } from './excel-upload/excel-upload.component';
import { FormBankerComponent } from './form-banker/form-banker.component';
import { ListBankerComponent } from './list-banker/list-banker.component';
import { DataTablesModule } from 'angular-datatables';
import { AppointmentsListComponent } from './appointments-list/appointments-list.component';
// Import à ajouter en haut
import { ListCollaborateurComponent } from './collaborateur/components/collaborateur-list/collaborateur-list.component';
import { CollaborateurService } from './collaborateur/services/collaborateur.service';
import { FormCollaborateurComponent } from './collaborateur/components/form-collaborateur/form-collaborateur.component';
import { ListSecteurActiviteComponent } from './secteur-activite/components/list-secteur-activite/list-secteur-activite.component';
import { SecteurActiviteService } from './secteur-activite/services/secteur-activite.service';
import { FormSecteurActiviteComponent } from './secteur-activite/components/form-secteur-activite/form-secteur-activite.component';
import { StatsEricComponent } from './collaborateur/components/stats-eric/stats-eric.component';
import { StatsYvanComponent } from './collaborateur/components/stats-yvan/stats-yvan.component';
import { StatsExpertComponent } from './collaborateur/components/stats-expert/stats-expert.component';
import { StatsJuvenalComponent } from './collaborateur/components/stats-juvenal/stats-juvenal.component';
import { SendPaymentComponent } from './send-payment/send-payment.component';
import { ReactiveFormsModule } from '@angular/forms';
import { PaymentRequestsComponent } from './payment-requests/payment-requests.component';

@NgModule({
    declarations: [
        AppComponent,
        AddClientComponent,
        ExcelUploadComponent,
        FormBankerComponent,
        ListBankerComponent,
        AppointmentsListComponent,
        ListCollaborateurComponent,
        FormCollaborateurComponent,
        ListSecteurActiviteComponent,
        FormSecteurActiviteComponent,
        StatsEricComponent,
        StatsYvanComponent,
        StatsExpertComponent,
        StatsJuvenalComponent,
        SendPaymentComponent,
        PaymentRequestsComponent,

       
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        SharedModule,
        AppRoutingModule,
        HttpClientModule,
        LayoutsModule,
        ErrorModule,
        ManageUserModule,
        CommonModule,
        ClientModule,
        ManageMailModule,
        ManageOffreModule,
        TranslateModule,
        ManageMenuModule,
        ManageProjectsModule,
        ManageUsersModule,
        DataTablesModule,
        ReactiveFormsModule,
        HttpClientModule,

    ],
    providers: [
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },

        CanActivateViaAuthGuard,
        NotAuthorizedAdminGuard,
        StorageService,
        AdminService,
        CustomerService,
        CanActivateViaAuthSuperAdminAuth,
        LoadPageService,
        StorageService,
        AuthGuard,
        MailService,
        OffreService,
        TranslateStore,
        LandingPageService,
        CollaborateurService,
        SecteurActiviteService,

    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
